import { createTheme } from "@mantine/core";

export const easyAppTheme = createTheme({
  primaryColor: "easyBlue",
  primaryShade: { light: 7, dark: 8 },
  defaultRadius: "md",
  cursorType: "pointer",
  fontFamily: '"Avenir Next", "Aptos", "Segoe UI Variable Display", "Trebuchet MS", sans-serif',
  fontFamilyMonospace: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
  headings: {
    fontFamily: '"Avenir Next", "Aptos", "Segoe UI Variable Display", "Trebuchet MS", sans-serif',
    fontWeight: "800",
  },
  radius: {
    xs: "4px",
    sm: "8px",
    md: "10px",
    lg: "12px",
    xl: "16px",
  },
  shadows: {
    sm: "0 8px 24px rgba(35, 44, 58, 0.06)",
    md: "0 12px 32px rgba(35, 44, 58, 0.10)",
  },
  defaultGradient: {
    from: "easyBlue.6",
    to: "easyBlue.8",
    deg: 135,
  },
  colors: {
    easyBlue: [
      "#f1f6ef",
      "#dde8d9",
      "#cadbc3",
      "#b4cdb0",
      "#9abc99",
      "#7fa580",
      "#638b67",
      "#4b7552",
      "#3d6043",
      "#2d4933",
    ],
    easyMint: [
      "#f6f8f2",
      "#edf2e7",
      "#dde6d4",
      "#cdd9c3",
      "#bbcbb0",
      "#a7bb9e",
      "#8ea088",
      "#73836d",
      "#5a6655",
      "#434d40",
    ],
    easyPeach: [
      "#fff8ea",
      "#fdf3df",
      "#faebcf",
      "#f6e1bb",
      "#eed6a5",
      "#e2c88a",
      "#c7ab6e",
      "#aa8d56",
      "#866c42",
      "#624c2e",
    ],
  },
  components: {
    Button: {
      defaultProps: {
        radius: "md",
        size: "md",
        color: "easyBlue",
      },
    },
    TextInput: {
      defaultProps: {
        radius: "md",
        size: "md",
      },
    },
    NativeSelect: {
      defaultProps: {
        radius: "md",
        size: "md",
      },
    },
    Badge: {
      defaultProps: {
        radius: "md",
      },
    },
    Paper: {
      defaultProps: {
        radius: "md",
        shadow: "sm",
      },
    },
  },
});
